import { makeStyles, useTheme } from '@material-ui/core/styles';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import VodPlayer from 'components/VodPlayer';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import VodName from './VodName';
import VodTrim from './VodTrim';
import VodPublish from './VodPublish';
const useStyles = makeStyles((theme) => ({
  previewWrapper: {
    marginTop: '1rem',
    width: '100%',
  },
  vodWrapper: {
    background: theme.palette.background.dark,
    border: '1px solid',
    borderColor: theme.palette.background.light,
    overflow: 'hidden',
  },
}));

const VodsTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [videoUrl, setVideoUrl] = useState('');
  const { vods, sessionId } = useSelector(({ conference }) => ({
    vods: (conference.Vod || [])
      .filter((vod) => vod.Url)
      .map((vod) => ({
        ...vod,
        Published: [null, undefined].includes(vod.Published) ? false : vod.Published,
        Duration: (moment.utc(vod.End).local().diff(moment.utc(vod.Start).local()) / (1000 * 60))
          .toFixed(0)
          .toString()
          .padStart(3, '0'),
      })),
    sessionId: conference.SessionId,
  }));

  const columns = [
    {
      name: 'Url',
      label: 'Preview',
      options: {
        filter: false,
        sort: false,
        searchable: false,
        customBodyRender: (url) => (
          <VideoLibraryIcon
            onClick={() => setVideoUrl(url)}
            style={{
              color: videoUrl === url ? theme.palette.primary.main : 'grey',
              cursor: 'pointer',
            }}
          />
        ),
      },
    },
    {
      name: 'Published',
      label: 'Published',
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customBodyRender: (published, { rowIndex }) => {
          return (
            <VodPublish
              color="primary"
              videoUrl={vods[rowIndex]?.Url}
              published={published}
              sessionId={sessionId}
            />
          );
        },
      },
    },
    {
      name: 'Name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (vodName, { rowIndex }) => (
          <VodName videoUrl={vods[rowIndex]?.Url} vodName={vodName} sessionId={sessionId} />
        ),
      },
    },
    {
      name: 'Duration',
      label: 'Duration (min)',
      options: {
        filter: false,
        sort: true,
        searchable: false,
      },
    },
    {
      name: 'Start',
      label: 'Start Time',
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value) => moment.utc(value).local().format('MMM D, YYYY h:mm:ss a'),
      },
    },
    {
      name: 'End',
      label: 'End Time',
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (value) => moment.utc(value).local().format('MMM D, YYYY h:mm:ss a'),
      },
    },
    {
      name: 'StartTime',
      label: 'Trim Start Time',
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (vodTime, { rowIndex }) => (
          <VodTrim videoUrl={vods[rowIndex]?.Url} vodTime={vodTime} sessionId={sessionId} />
        ),
      },
    },
    {
      name: 'EndTime',
      label: 'Trim End Time',
      options: {
        filter: false,
        sort: true,
        searchable: false,
        customBodyRender: (vodTime, { rowIndex }) => (
          <VodTrim videoUrl={vods[rowIndex]?.Url} vodTime={vodTime} sessionId={sessionId} isMax />
        ),
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    sortOrder: { name: 'name', direction: 'asc' },
    filterType: 'select',
    selectableRows: false,
  };

  return (
    <>
      {Boolean(videoUrl) && (
        <div className={classes.previewWrapper}>
          <div className={classes.vodWrapper}>
            <VodPlayer vodUrl={videoUrl} />
          </div>
        </div>
      )}
      <MUIDataTable
        style={{ width: '100%' }}
        title="Recorded Session Videos"
        data={vods}
        columns={columns}
        options={options}
      />
    </>
  );
};

export default VodsTable;
